import { useEffect, useState } from 'react';

/** Aligné avec le breakpoint des fonds widget (`background_image` vs `background_image_mobile`). */
export const MOBILE_BREAKPOINT = 768;

/**
 * `true` si `window.innerWidth < MOBILE_BREAKPOINT`.
 * Premier rendu : `false` tant que l’effet n’a pas mesuré (évite le flash SSR côté client pur).
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
